// extracted by mini-css-extract-plugin
module.exports = {"container":"TenantsPage_container__nB-7W"};